// src/hooks/useAnalytics.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageview } from '../lib/analytics';

export default function useAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (import.meta.env.DEV) return;
    pageview(location.pathname + location.search);
  }, [location]);
}
